angular.module('mercury.modules.reports.labour')
.config(["$stateProvider", function($stateProvider) {

  $stateProvider.state('Reports.LabourOverview', {
    url: '/labour/overview?report',
    templateUrl: 'modules/reports/labour/overview.tpl.html',
    controller: 'ReportsLabourOverviewCtrl'
  });

  // Budget Analysis
  $stateProvider.state('Reports.LabourAnalysis', {
    url: '/labour/analysis?report',
    templateUrl: 'modules/reports/labour/analysis.tpl.html',
    controller: 'ReportsLabourAnalysisCtrl'
  });

  // Roster vs Actual
  $stateProvider.state('Reports.LabourVariance', {
    url: '/labour/variance?report',
    templateUrl: 'modules/reports/labour/variance.tpl.html',
    controller: 'ReportsLabourVarianceCtrl'
  });

  // Food vs Beverage
  $stateProvider.state('Reports.LabourCostCentre', {
    url: '/labour/costcentre?report',
    templateUrl: 'modules/reports/labour/costcentre.tpl.html',
    controller: 'ReportsLabourCostCentreCtrl'
  });

  // Todo: check if this can be combined with the LabourVariance report above
  $stateProvider.state('Reports.LabourVarianceRole', {
    url: '/labour/variancerole?report',
    templateUrl: 'modules/reports/labour/variancerole.tpl.html',
    controller: 'ReportsLabourVarianceRoleCtrl'
  });
}]);
